"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneTimeTokenIn = void 0;
class OneTimeTokenIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return OneTimeTokenIn.attributeTypeMap;
    }
}
exports.OneTimeTokenIn = OneTimeTokenIn;
OneTimeTokenIn.discriminator = undefined;
OneTimeTokenIn.attributeTypeMap = [
    {
        "name": "oneTimeToken",
        "baseName": "oneTimeToken",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=OneTimeTokenIn.js.map